export default __webpack_public_path__ + "assets/f4f1a024fca4675284ee14925efbdb4e/02.jpg";